export enum VAR_STATIC {
  CUC = 8,
}

export enum COD_MONEDA {
  SOLES = "SOL",
  DOLAR = "DOL",
}

// RENDIMIENTOS
export enum FILTRO_RENDI {
  UN_ANIO = 1,
  TRES_ANIO = 2,
  CINCO_ANIO = 3,
  TODO_ANIO = 4,
}

export enum FLAG_FILTRO_RENDI {
  S = "S",
  N = "N",
}

export enum TIPO_FONDO {
  MUTUO = "MUT",
  INVERSION = "INV",
  ALL = "ALL"
}

export enum COD_CASE_PORTAF {
  CASE1 = "20",
  CASE2 = "21",
  CASE3 = "22",
  CASE4 = "23",
  CASE5 = "99",
}

// CUC A CUC
export enum ESTADOS_TRANSFER {
  PEN = "PEN",
  ACP = "ACP",
  RHZ = "RHZ",
  DES = "DES",
  APR = "APR",
  PEN_DES = "Pendiente",
  ACP_DES = "Aceptada",
  RHZ_DES = "Rechazada",
  DES_DES = "Desestimada",
  APR_DES = "Finalizada",
}

export const ESTADOS_COLOR_TRANSFER = [
  { id: ESTADOS_TRANSFER.PEN, nombre: ESTADOS_TRANSFER.PEN_DES, estilo: 'pend' },
  { id: ESTADOS_TRANSFER.ACP, nombre: ESTADOS_TRANSFER.ACP_DES, estilo: 'acep' },
  { id: ESTADOS_TRANSFER.RHZ, nombre: ESTADOS_TRANSFER.RHZ_DES, estilo: 'rech' },
  { id: ESTADOS_TRANSFER.DES, nombre: ESTADOS_TRANSFER.DES_DES, estilo: 'dese' },
  { id: ESTADOS_TRANSFER.APR, nombre: ESTADOS_TRANSFER.APR_DES, estilo: 'apro' },
]

export enum FLAG_BLOQUEO {
  S = "S",
  N = "N",
}

export enum FLAG_FUERA_HORA {
  S = "S",
  N = "N",
}

//LOGIN
export enum ESTADO_RESET_PASS {
  FORCE_CHANGE = "FORCE_CHANGE_PASSWORD",
  CONFIRMED = "CONFIRMED",
  RESET_REQ = "RESET_REQUIRED"
}

//LINKS
export enum LINK_EXTERNO {
  PRODUCTOS = "https://www.fondossura.pe/productos",
}